import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import RichTextEditor from 'components/editor/RichTextEditor';
import { ModalContainer } from './ownerNotesModal.styles';

export const ownerNotesModalId = 'owner-notes-modal';

interface OwnerNotesModalProps {
  notes: string;
  onClose: () => void;
}

const OwnerNotesModal: React.FC<OwnerNotesModalProps> = ({
  notes,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <ModalContainer>
      <Modal.Header closeButton>
        <Modal.Title>{t('pageProperties.agencyNotes')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <RichTextEditor
          id="owner-notes-modal-editor"
          contents={notes}
          readOnly
          controlsSettings={{
            attachmentsAvailable: false,
            attachmentIconDisabled: false,
            isLoading: false,
            clearEditorButton: false,
          }}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button
          bsStyle="primary"
          onClick={onClose}
          data-testid="owner-notes-modal-ok-button"
        >
          {t('pageProperties.ok')}
        </Button>
      </Modal.Footer>
    </ModalContainer>
  );
};

export default OwnerNotesModal;
